"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactDatepicker = require("react-datepicker");

var _ptBR = _interopRequireDefault(require("date-fns/locale/pt-BR"));

var _ = require("../");

var _datePickerStyles = _interopRequireDefault(require("./datePickerStyles"));

var _styles = _interopRequireDefault(require("./styles"));

var _excluded = ["closeOnSelect", "label", "selected", "onChange", "name", "ranged", "twoMonths"];
var Datepicker = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var closeOnSelect = _ref.closeOnSelect,
      label = _ref.label,
      selected = _ref.selected,
      _onChange = _ref.onChange,
      name = _ref.name,
      ranged = _ref.ranged,
      twoMonths = _ref.twoMonths,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  (0, _reactDatepicker.registerLocale)('ptBR', _ptBR.default);

  var checkScreenWidth = function checkScreenWidth() {
    var screenWidth = window.innerWidth;
    if (screenWidth < 820) return 1;
    return 2;
  };

  var monthsShown = twoMonths ? checkScreenWidth() : 1;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_datePickerStyles.default, null), /*#__PURE__*/_react.default.createElement(_styles.default, Object.assign({
    ref: ref,
    name: name,
    shouldCloseOnSelect: closeOnSelect,
    customInput: /*#__PURE__*/_react.default.createElement(_.Input, {
      label: label,
      rightIcon: /*#__PURE__*/_react.default.createElement(_.Icon, {
        name: "calendar",
        width: "24",
        height: "24"
      })
    }),
    locale: "ptBR",
    selectsRange: ranged,
    monthsShown: monthsShown,
    selected: selected,
    onChange: function onChange(e) {
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
    }
  }, rest)));
});
Datepicker.defaultProps = {
  showTimeSelect: false,
  showYearDropdown: false,
  closeOnSelect: false,
  ranged: false,
  twoMonths: false
};
var _default = Datepicker;
exports.default = _default;